import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { verdictMeta } from "@/utils/news";

export default function FactCheckPanel() {
  const items = topics
    .filter((topic) => topic.status !== "tracking")
    .flatMap((topic) => topic.factChecks.map((check) => ({ check, topic })))
    .slice(0, 4);

  return (
    <section className="rounded-lg border border-secondary-200 bg-secondary-50 px-4 py-10 md:px-8 md:py-12">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最近完成的辟谣核查</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            把流传的说法拆成一句话，再比对公开信息，给出四档结论：属实 / 不实 / 部分属实 / 暂无定论。
          </p>
        </div>
        <Link
          to="/category/piyao"
          className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-secondary-700 transition-colors hover:text-secondary-800"
        >
          进入辟谣核查
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
        {items.map(({ check, topic }) => {
          const verdict = verdictMeta(check.verdict);
          return (
            <Link
              key={`${topic.id}-${check.claim}`}
              to={`/topic/${topic.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-400"
            >
              <div className="flex items-start justify-between gap-3">
                <p className="font-heading text-sm font-semibold leading-snug text-foreground-950">
                  “{check.claim}”
                </p>
                <span className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium ${verdict.className}`}>
                  <i className={`${verdict.icon} text-xs`} aria-hidden="true"></i>
                  {verdict.label}
                </span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{check.detail}</p>
              <span className="mt-auto inline-flex items-center gap-1 pt-4 text-xs font-medium text-secondary-700 transition-colors group-hover:text-secondary-800">
                来自：{topic.title}
                <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}